const isDebugEnabled = () => {
  if (process.env.NODE_ENV !== 'production') return true
  try {
    return typeof window !== 'undefined' && window.localStorage?.getItem('debug') === 'true'
  } catch (_) {
    return false
  }
}

export const debugLog = (...args) => {
  if (isDebugEnabled()) console.log(...args)
}

export default debugLog
